<template>
  <div>
    <div class="d-flex justify-content-center">
      <BaseInput
        v-model="inputValue"
        is-centered
        :placeholder="placeholder"
        @keyup.enter.native="handleSubmit"
      />
    </div>
    <BaseButton
      class="mb-3 d-flex justify-content-center"
      font-size="small"
      :is-disabled="!inputValue"
      is-rounded
      @click="handleSubmit"
    >
      <span class="px-2">
        <font-awesome-icon :icon="icon" />
        <span class="pl-2">{{ buttonText }}</span>
      </span>
    </BaseButton>
  </div>
</template>

<script>
import BaseInput from '@/components/Atoms/Form/BaseInput'
import BaseButton from '@/components/Atoms/BaseButton'
export default {
  name: 'TheCreateOrJoinClan',
  components: { BaseButton, BaseInput },
  props: {
    icon: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('onFormSubmit', this.inputValue)
    },
  },
}
</script>

<style scoped>

</style>
